<sui-dialog-tabs>
  <ng-template suiDialogLeftHeader>
    @if (objectActionIcon) {
      <fa-icon [icon]="objectActionIcon"></fa-icon>
    }
    <h2 ngpDialogTitle>{{ objectActionTitle }}</h2>
  </ng-template>

  <ng-template suiDialogLeftContent>
    <app-search-input
      [placeholder]="'widget-settings-popup.search.search' | translate"
      (inputChanged)="onSearchInput($event)"
    ></app-search-input>

    <app-dialog-tab-nav
      [tabs]="visibleTabs"
      [activeId]="tabManager.activeTabId()"
      [invalidIds]="visibleInvalidTabIds"
      [invalidCounts]="visibleInvalidFieldCounts"
      (tabSelect)="tabManager.selectTab($event)"
    />
  </ng-template>

  <ng-template suiDialogRightHeader>
    <div class="right-header-content">
      @if (objectIcon) {
        <fa-icon [icon]="objectIcon"></fa-icon>
      }
      <h2 ngpDialogDescription>{{ objectTitle ?? objectTitleDefault }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogRightContent>
    <ng-container #tabHost></ng-container>
  </ng-template>

  <ng-template suiDialogRightFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button variant="primary" (click)="save()">
      {{ "btn.confirm" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-tabs>
